import { render, staticRenderFns } from "./PortalFooter.vue?vue&type=template&id=4cdd3a56"
import script from "./PortalFooter.vue?vue&type=script&lang=js"
export * from "./PortalFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports